import React from 'react';
import moment from 'moment-timezone';
import { DateTimeDisplay } from './date-time-display';
import { WIDGET_LOCALE } from '../../locale-wrapper';

const FRENCH_LANGUAGE_MAPPING = {
  'Do MMM': 'MMM Do',
  'Do MMMM': 'MMMM Do',
  'Do MMMM YYYY': 'MMMM Do YYYY',
  'ddd Do MMMM': 'ddd MMMM Do',
  'ddd Do MMMM YYYY': 'ddd MMMM Do YYYY',
  'dddd Do MMMM YYYY': 'dddd MMMM Do YYYY',
  'dDDD Do MMMM YYYY': 'dDDD MMMM Do YYYY',
};

const DATE_TO_FRENCH_LANGUAGE_MAPPING = {
  // fr: FRENCH_LANGUAGE_MAPPING,
};

const getFormat = (format, locale = 'en') => {
  const mapping = DATE_TO_FRENCH_LANGUAGE_MAPPING[locale];
  if (!mapping) return format;
  const mappedFormat = FRENCH_LANGUAGE_MAPPING[format];
  if (!mappedFormat) return format;

  return mappedFormat;
};

export const EventDate = ({ event, settings, format, className = '' }) => {
  const dateTBD = event.get('date_tbd');
  if (dateTBD) return <span />;
  const startTime = event.getIn(['date', 'start', 'utc']);
  const endTime = event.getIn(['date', 'end', 'utc']);
  const timeZone = settings.get('automaticTimezone') ? moment.tz.guess() : event.getIn(['date', 'start', 'timezone']);

  let momentStartTime = moment(startTime);
  let momentEndTime = moment(endTime);
  if (startTime && timeZone) {
    momentStartTime = moment(startTime).tz(timeZone);
    momentEndTime = moment(endTime).tz(timeZone);
  } else {
    momentStartTime = moment(startTime).utc();
    momentEndTime = moment(endTime).utc();
  }

  const locale = event.get('type') === 'eventviewer' ? WIDGET_LOCALE : event.get('locale', 'en').split('_')[0];

  const momentStartLocale = momentStartTime.locale(locale);
  const momentEndLocale = momentEndTime.locale(locale);

  const dateFormat = locale === 'it' ? settings.get('dateFormat').replace('o', '') : getFormat(settings.get('dateFormat'), locale);

  return (
    <DateTimeDisplay
      settings={settings}
      showStart={settings.get('showStartDate', false)}
      showEnd={settings.get('showEndDate', false)}
      momentStartLocale={momentStartLocale}
      momentEndLocale={momentEndLocale}
      format={format || dateFormat}
      className={className}
    />
  );
};
